import React, {useEffect, useState} from 'react';
import './App.scss';
import Pagination from '@material-ui/lab/Pagination';

function App() {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [authors, setAuthors] = useState({});
    const [pageSize] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const urlPublications = '/ads/publications.json';
    const urlAuthors = '/ads/authors.json';
    // const urlPublications = 'http://localhost:3000/publications.json';
    // const urlAuthors = 'http://localhost:3000/authors.json';

    useEffect(() => {
        fetch(urlPublications)
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItems(result);
                    setPageCount(Math.ceil(result.length/pageSize));
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
        fetch(urlAuthors)
            .then(res => res.json())
            .then(
                (result) => {
                    setAuthors(result);
                },
                (error) => {
                    setError(error);
                }
            )
    }, [])

    const handlePageChange = (e,page) => {
        setCurrentPage(page);
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div>Loading...</div>;
    } else {
        return (
            <div className='CTAC-publications'>
                <div className='publications-count'>{items.length} Publications</div>
                <ul>
                    {items.slice((currentPage-1)*pageSize, (currentPage-1)*pageSize + pageSize).map(item => (
                        <li key={item.bibcode} className='publication-item'>
                            <div className='left'>
                                <h3 className='title'><a href={'https://ui.adsabs.harvard.edu/abs/'+item.bibcode} target='_blank'>{item.title}</a></h3>
                                <div className='author'>
                                    {
                                        item.author.slice(0,20).map(name => {
                                            if (name in authors) return (<a href={authors[name]} key={name}><strong>{name}; </strong></a>);
                                            else return (<span key={name}>{name}; </span>)
                                        })
                                    }
                                    {
                                        item.author.length > 20 ? <span>and more...</span> : null
                                    }
                                </div>
                            </div>
                            <div className='right'>
                                <div className='date'>
                                    {item.date}
                                </div>
                                <div className='pub'>
                                    {item.pub}
                                </div>
                            </div>
                        </li>
                    ))}
                    <Pagination count={pageCount} onChange={handlePageChange} size='large' />
                </ul>
            </div>
        );
    }
}

export default App;
